import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { right } from '@popperjs/core';
import {
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  mainModuleName,
  rolesModuleName,
} from '@piqet-angular/shared';
import { MyOrganizationFacade, getRolesAndPermission } from '@piqet-angular/data';
import { Subject } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
@Injectable({
  providedIn: 'root',
})
export class ManageTeamsDataGridService {
  event: any;
  Access: any;
  manageTeamsPayload: any;
  editDatas = new Subject<[any, any, any]>();
  teamObservable$ = this.editDatas.asObservable();
  deleteData = new Subject<[any, any, any]>();
  teamDeleteObservable$ = this.deleteData.asObservable();

  constructor(
    private myOrganizationFacade: MyOrganizationFacade,
    private swalService: SwalService
  ) {}

  getManageTeamsDataColumn(pathName: any): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'Id',
      headerName: 'Id',
      field: 'Id',
      hide: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Name',
      headerName: 'Name',
      field: 'name',
      minWidth: grid_widths_map.lg_column_sm,
      cellClass: 'my-permission-cursor-pointer',
      sortable: true,
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      cellRenderer: 'emailRenderer',
      filter: 'agTextColumnFilter',
      cellRendererParams: {
        gridName: 'team',
      },
      comparator: customComparator,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'OrganizationName',
      headerName: 'Organization',
      field: 'organizationName',
      minWidth: grid_widths_map.sm_column_sm,

      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      cellRendererParams: {
        suppressDragLeaveHidesColumns: true,
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'NumberofUsers',
      headerName: 'No. of users',
      field: 'numberofUsers',
      minWidth: grid_widths_map.sm_column_xm,

      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agNumberColumnFilter',
      cellRendererParams: {
        suppressDragLeaveHidesColumns: true,
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      cellRendererParams: {
        showEdit: this.isAccess(pathName) ? this.isAccess(pathName).isEdit : true,
        showDelete: this.isAccess(pathName) ? this.isAccess(pathName).isDelete : true,
        value: 'manageTeams',
        deleteData: (data: any, customName: any) => {
          // this.myOrganizationFacade.openMyOrgDeleteModal(data.id, "/MyOrganizationTeam/DeleteMyOrganizationTeam?id", customName);
          this.deleteteamDataConfirmation(
            data.id,
            '/MyOrganizationTeam/DeleteMyOrganizationTeam?id',
            customName
          );
        },
        editData: (data: any, pathName: any) => {
          // this.myOrganizationFacade.openAddEditMyTeamsModal(data.id, 'Update team', pathName)
          this.editDatas.next([data.id, 'Update team', pathName]);
        },
      },
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });

    return colDef;
  }

  isAccess = (pathName: any) => {
    return pathName.includes('Admin')
      ? getRolesAndPermission(
          rolesModuleName.AdministratorTeams,
          mainModuleName.userManagementModule
        )
      : getRolesAndPermission(
          rolesModuleName.myOrganizationManageTeam,
          mainModuleName.myOrganizationModule
        );
  };

  deleteteamDataConfirmation(data: any, customType: any, pathName: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteData.next([data, customType, pathName]);
      }
    });
  }
}

const customComparator = (valueA: any, valueB: any) => {
  return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
};
